/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4d93826e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-alarm-detail"
};
var _hoisted_2 = {
  class: "device-alarm-info"
};
var _hoisted_3 = {
  class: "van-collapse-content"
};
var _hoisted_4 = {
  class: "content-item"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "content-item-label"
  }, "处理结果:", -1);
});
var _hoisted_6 = {
  class: "content-item-value"
};
var _hoisted_7 = {
  class: "content-item"
};
var _hoisted_8 = {
  class: "content-item-label"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "图片:", -1);
});
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 0,
  class: "content-item-value van-image-list"
};
var _hoisted_12 = {
  key: 1
};
var _hoisted_13 = ["src"];
import { getWarnDetail } from '@/service/deviceAlarm/index';
// import ContentPage from '@/components/ContentPage/index.vue';
import './common.less';
import './detail.less';
export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup: function setup(__props) {
    var route = useRoute();
    var id = route.query.id;
    var listloading = ref(false);
    var finished = ref(false);
    var imagePreShow = ref(false);
    var imgUrl = ref([]);
    var startPosition = ref(0);
    var dealWithResult = ref('');
    var fileType = ref(1);
    var imgClick = function imgClick(index) {
      startPosition.value = index;
      imagePreShow.value = true;
    };
    var onLoad = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onLoad() {
        return _ref.apply(this, arguments);
      };
    }();
    // 判断是否是图片
    var getFileImage = function getFileImage(name) {
      var reg = /png$|jpeg$|gif$|jpg$/;
      return reg.test(name);
    };
    var videoRef = function videoRef(event) {
      if (event) {
        event['disablePictureInPicture'] = true;
      }
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var detailRes, resData, eaDeviceWarnAttachments, url, urlStr;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            listloading.value = true;
            _context2.next = 4;
            return getWarnDetail(id);
          case 4:
            detailRes = _context2.sent;
            resData = (detailRes === null || detailRes === void 0 ? void 0 : detailRes.data) || {};
            dealWithResult.value = (resData === null || resData === void 0 ? void 0 : resData.dealWithResult) || '';
            eaDeviceWarnAttachments = (resData === null || resData === void 0 ? void 0 : resData.eaDeviceWarnAttachments) || [];
            url = eaDeviceWarnAttachments.map(function (item) {
              return item.attachmentUrl;
            });
            console.log(url, 'url');
            urlStr = url.join(',');
            if (getFileImage(urlStr)) {
              fileType.value = 1;
            }
            if (!getFileImage(urlStr)) {
              fileType.value = 2;
            }
            imgUrl.value = url;
            listloading.value = false;
            finished.value = true;
            _context2.next = 22;
            break;
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](0);
            listloading.value = false;
            finished.value = true;
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 18]]);
    })));
    return function (_ctx, _cache) {
      var _component_van_image_preview = _resolveComponent("van-image-preview");
      var _component_van_image = _resolveComponent("van-image");
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
        loading: _unref(listloading),
        "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(listloading) ? listloading.value = $event : null;
        }),
        finished: _unref(finished),
        onLoad: onLoad
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(dealWithResult) || '--'), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _unref(imgUrl).length == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "--")) : _createCommentVNode("", true)])]), _unref(imgUrl).length > 0 && _unref(fileType) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_image_preview, {
            show: _unref(imagePreShow),
            "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(imagePreShow) ? imagePreShow.value = $event : null;
            }),
            images: _unref(imgUrl),
            "start-position": _unref(startPosition)
          }, null, 8, ["show", "images", "start-position"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgUrl), function (item, index) {
            return _openBlock(), _createBlock(_component_van_image, {
              key: index,
              fit: "cover",
              position: "left",
              src: item,
              onClick: function onClick() {
                return imgClick(index);
              }
            }, null, 8, ["src", "onClick"]);
          }), 128))])) : _createCommentVNode("", true), _unref(imgUrl).length > 0 && _unref(fileType) == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("video", {
            src: _unref(imgUrl)[0],
            class: "video-content",
            controls: "",
            ref: videoRef,
            controlslist: "nodownload noremoteplayback noplaybackrate"
          }, null, 8, _hoisted_13)])) : _createCommentVNode("", true)])])])];
        }),
        _: 1
      }, 8, ["loading", "finished"])]);
    };
  }
});